// extracted by mini-css-extract-plugin
export default {"container":"mutualfund_container__WtsQU","breadCrumb":"mutualfund_breadCrumb__X1lWs"};